<script setup>
import { ref, onMounted, computed } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { sendAdriver } from '@/utils/metrika';
import { sendMetrik } from "@/utils/metrika";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";

const storeScroll = useScrollStore();
const mainScreen = ref(null);

onMounted(async () => {});
</script>
<template>
	<section class="main-screen" ref="mainScreen" :style="{ paddingTop: storeScroll.paddingTop }">
		<div class="container">
			<div class="main-screen__container">
				<div class="main-screen__content">
					<p class="main-screen__top-text">с&nbsp;1&nbsp;декабря 2025&nbsp;г.&nbsp;по&nbsp;31&nbsp;января 2026&nbsp;г.</p>
					<h1 class="main-screen__title title1">Великое Искусство</h1>
					<BaseButtonUploadReceipt @click="sendAdriver('go'), sendMetrik('reachGoal','Go')" class="main-screen__btn --blue">Участвовать</BaseButtonUploadReceipt>
				</div>
				<picture class="main-screen__image">
					<source media="(max-width: 480px)" srcset="@/assets/img/main/main_img_mobile.webp" />
					<img width="954" height="741" src="@/assets/img/main/main_img.webp" alt="изображение" />
				</picture>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.main-screen {
	position: relative;
	background-image: url("@/assets/img/main/main_bg.webp");
	background-repeat: no-repeat;
	background-position: center; /* x y*/
	background-size: cover; /* w h*/
	@media (max-width: vars.$xx) {
		background-image: url("@/assets/img/main/main_bg_mobile.webp");
	}
	&::before {
		position: absolute;
		content: "";
		background-image: url("@/assets/img/main/main_line_bg.webp");
		background-repeat: no-repeat;
		background-size: contain; /* w h*/
		width: 65rem;
		height: 21.5rem;
		bottom: 0;
		right: 0;
		@media (max-width: vars.$xx) {
			width: 64rem;			
		}
		@media (max-width: vars.$x480) {
			width: 21rem;
			height: 7rem;
		}
	}
}
.main-screen__container {
	display: flex;
	align-items: start;
	justify-content: space-between;
	gap: 3rem;
	padding-top: 2.5rem;
	@media (max-width: vars.$mn) {
		align-items: end;
	}
	@media (max-width: vars.$xx) {
		flex-direction: column;
		align-items: start;
		padding-top: 1.7rem;
		gap: 4rem;
	}
}
.main-screen__content {
	display: grid;
	gap: 6rem;
	max-width: 60.2rem;
	flex-shrink: 0;
	padding-top: 2rem;
	@media (max-width: vars.$mn) {
		max-width: 55%;
		padding: 0 0 2rem;
	}
	@media (max-width: vars.$xx) {
		padding: 0;
		gap: 2.4rem;
	}
}
.main-screen__top-text {
	font-weight: 700;
	font-size: 2.4rem;
	line-height: 140%;
	color: #fff;
	@media (max-width: vars.$x480) {
		font-weight: 300;
		font-size: 1.7rem;
	}
}
.main-screen__title {
}
.main-screen__btn {
	width: fit-content;
}
.main-screen__image {
	margin-right: -7.5rem;
	@media (max-width: vars.$l) {
		margin-right: 0;
	}
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.8s ease, transform 0.8s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(100%);
}
</style>
